import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Shop from './components/Shop';
import ProductDetails from './components/ProductDetails';
import Login from './components/admin/Login';
import AdminLayout from './components/admin/AdminLayout';
import ProductList from './components/admin/ProductList';
import ProductEdit from './components/admin/ProductEdit';
import AdminSettings from './components/admin/AdminSettings';
import InstagramPreview from './components/InstagramPreview';

const ProtectedRoute = ({ children }) => {
    const token = localStorage.getItem('adminToken');
  if (!token) return <Navigate to="/admin/login" replace />;
    return children;
};

function App() {
  return (
    <Router>
      <Toaster position="top-center" reverseOrder={false} />
      <Routes>
        <Route path='/' element={<Shop />} />
        <Route path='/product/:id' element={<ProductDetails />} />
        <Route path='/preview/instagram' element={<InstagramPreview />} />
        
        {/* Админка */}
        <Route path='/admin/login' element={<Login />} />
        
        <Route path='/admin' element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }>
            <Route index element={<ProductList />} />
            <Route path="products" element={<ProductList />} />
            <Route path="add" element={<ProductEdit />} />
            <Route path="edit/:id" element={<ProductEdit />} />
            <Route path="settings" element={<AdminSettings />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
